module.exports = __webpack_public_path__ + "media/images/main/k4-5d0aa7212c4025efb1e0f2400d898a06.jpg";